function toggle_element(id, key, profile, set_profile_data) {
    if (parseInt(id[0]) in profile[key]) {
        remove_element(id, key, profile, set_profile_data)
    } else {
        add_element(id, key, profile, set_profile_data)
    }
}
function add_element(id, key, profile, set_profile_data) {
    const original = { ...profile[key] }
    for (const r of id.flat()) {
        original[parseInt(r)] = true
    }
    const original_profile = {
        ...profile,
    }
    original_profile[key] = original
    set_profile_data(original_profile)
}
function remove_element(id, key, profile, set_profile_data) {
    const original = { ...profile[key] }
    for (const r of id.flat()) {
        delete original[parseInt(r)]
    }
    const original_profile = {
        ...profile,
    }
    original_profile[key] = original
    set_profile_data(original_profile)
}

export function toggle_nameplate(id, profile, set_profile_data) {
    toggle_element([id], "NamePlateBgMap", profile, set_profile_data)
}
export function add_nameplate(id, profile, set_profile_data) {
    add_element([id], "NamePlateBgMap", profile, set_profile_data)
}
export function remove_nameplate(id, profile, set_profile_data) {
    remove_element([id], "NamePlateBgMap", profile, set_profile_data)
}

export function toggle_byname_adjective(id, profile, set_profile_data) {
    toggle_element([id], "BynameAdjectiveMap", profile, set_profile_data)
}
export function add_byname_adjective(id, profile, set_profile_data) {
    add_element([id], "BynameAdjectiveMap", profile, set_profile_data)
}
export function remove_byname_adjective(id, profile, set_profile_data) {
    remove_element([id], "BynameAdjectiveMap", profile, set_profile_data)
}

export function toggle_byname_subject(id, profile, set_profile_data) {
    toggle_element([id], "BynameSubjectMap", profile, set_profile_data)
}
export function add_byname_subject(id, profile, set_profile_data) {
    add_element([id], "BynameSubjectMap", profile, set_profile_data)
}
export function remove_byname_subject(id, profile, set_profile_data) {
    remove_element([id], "BynameSubjectMap", profile, set_profile_data)
}

export function toggle_emote(id, profile, set_profile_data) {
    toggle_element([id], "EmoteMap", profile, set_profile_data)
}
export function add_emote(id, profile, set_profile_data) {
    add_element([id], "EmoteMap", profile, set_profile_data)
}
export function remove_emote(id, profile, set_profile_data) {
    remove_element([id], "EmoteMap", profile, set_profile_data)
}

export function toggle_goods(id, profile, set_profile_data) {}
export function add_goods(id, profile, set_profile_data) {}
export function remove_goods(id, profile, set_profile_data) {}

export function toggle_byname(raw1, raw2, profile, set_profile_data) {}
export function add_byname(raw1, raw2, profile, set_profile_data) {
    const byname_adjective_original = { ...profile.BynameAdjectiveMap }
    const byname_subject_original = { ...profile.BynameSubjectMap }
    for (const r of raw1) {
        byname_adjective_original[parseInt(r)] = true
    }
    for (const r of raw2) {
        byname_subject_original[parseInt(r)] = true
    }
    const original_profile = {
        ...profile,
        BynameAdjectiveMap: byname_adjective_original,
        BynameSubjectMap: byname_subject_original,
    }
    set_profile_data(original_profile)
}
export function remove_byname(raw1, raw2, profile, set_profile_data) {}
